import { enviroment } from "../../enviroment";
import { useAuthHttpClient } from "./useAuthHttpClient";
import { throwIfNotSuccess } from "./throwIfNotSuccess";

const API_URL = `${enviroment.apiUrl}/api/v1/statistics`;

export function useStatisticsService(): StatisticsService {
    const { authFetch } = useAuthHttpClient();

    async function getStatistic(from: Date, to: Date): Promise<Blob> {
        const url =
            API_URL + `?from=${from.toISOString()}&to=${to.toISOString()}`;
        const response = await authFetch(url, {
            method: "GET",
            headers: { "Content-Type": "text/csv" }
        });

        throwIfNotSuccess(response);
        return response.blob();
    }

    return {
        getStatistic
    } as StatisticsService;
}

export interface StatisticsService {
    getStatistic(from: Date, to: Date): Promise<Blob>;
}
